import { v1Post } from '@/services/v1Api';

/**
 * POST /api/v1/newsletter-signup – public signup for email updates (splash page).
 * @param {string} email
 * @param {string} [source='splash']
 * @returns {Promise<{ message: string }>}
 * @throws on 422 (validation) with response.data.errors
 */
export async function signup(email, source = 'splash') {
    const { data, meta } = await v1Post('/api/v1/newsletter-signup', { email, source });
    return {
        ...(typeof data === 'object' && data ? data : {}),
        message: meta?.message ?? data?.message,
    };
}
